import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { ShowLoaderScreenService } from '../services/show-loader-screen.service';

export const authGuard: CanActivateFn = (route, state) => {
   const _Router = inject(Router);
  const _StorageService = inject(StorageService);
  const _ShowLoaderScreenService = inject(ShowLoaderScreenService);

  // Logic to verify token here
  _ShowLoaderScreenService.hide()
  if (_StorageService.token) {
    return true;
  } else {
    _Router.navigate(['login']);
    return false;
  }
};
